// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"29850ab0","449":"29850ab0","768":"29850ab0","779":"29850ab0"}[chunkId] + ".chunk.css";
};